"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "camerata-cornello": {
    "377d8386": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "skipSearch": false
    }],
    "brembella": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a71a6992": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "skipSearch": false
    }],
    "bretto": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a932cb65": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "skipSearch": false
    }],
    "bruga": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e8ef764d": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "skipSearch": false
    }],
    "cespedosio": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e17943e": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "skipSearch": false
    }],
    "cornello": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2a879ce": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "skipSearch": false
    }],
    "era": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "925014ca": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "skipSearch": false
    }],
    "orbrembo": [{
      "hkey": "69a38baf",
      "slug": "camerata-cornello",
      "name": "Camerata Cornello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;